import { render } from "./weekdayController.vue?vue&type=template&id=c2a1e354&scoped=true"
import script from "./weekdayController.vue?vue&type=script&lang=js"
export * from "./weekdayController.vue?vue&type=script&lang=js"

import "./weekdayController.vue?vue&type=style&index=0&id=c2a1e354&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a1e354"]])

export default __exports__